import { InvalidFieldError } from '../../validation/errors/invalid-field-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'
import { type ValidateDocumentAdapter } from '../../validation/protocols/validate-document-adapter'

export class DocumentValidation implements FieldValidation {
  private readonly validateDocumentAdapter: ValidateDocumentAdapter
  readonly field: string

  constructor (field: string, validateDocumentAdapter: ValidateDocumentAdapter) {
    this.field = field
    this.validateDocumentAdapter = validateDocumentAdapter
  }

  validate (value: string): Error | null {
    const isValid = this.validateDocumentAdapter.validate(value)
    return isValid ? null : new InvalidFieldError('CPF ou CNPJ')
  }
}
